import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { loadInitialTheme } from './component/themeChangeComponent';
import Product from "./component/product"; // Adjust path as needed
import History from "./component/history"; // Adjust path as needed
import NotFound from "./component/NotFound"; // Adjust path as needed
import AdminDashboard from "./component/AdminDashboard";
import WinnerAnnouncement from "./component/static-pages/WinnerAnnouncement";
import Login from "./component/Login";
import AuthGuard from "./component/AuthGuard";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import "./css/style.css";
import "./css/common.css";
import "./css/media-queries.css";
import "animate.css/animate.min.css";

loadInitialTheme();

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<History />} />

          <Route path="/Product/verify/01/:productId" element={<Product />} />
          <Route path="/Product/verify/21/:sno" element={<Product />} />
          <Route
            path="/Product/verify/01/:productId/10/:lot/21/:sno"
            element={<Product />}
          />
          <Route
            path="/Product/verify/01/:productId/21/:sno"
            element={<Product />}
          />
          <Route path="/Product/NotFound" element={<NotFound />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/admin/dashboard" element={
            <AuthGuard>
              <AdminDashboard />
            </AuthGuard>
          } />
          <Route path="/static-pages/winner-page" element={<WinnerAnnouncement />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
